import React from 'react';
import { LoginButton } from '../../Header/LoginButton';
import { b2bData } from '../../cms/layout/components/header';
import { DesktopNavBar } from './DesktopHeader';
import { MobileNavBar } from './MobileHeader';
import { TNAVBAR_DATA } from './types';
import { ButtonVariants } from '../../Atoms/Button';
import { productReturnPath } from '../../../utils/SSOLogin';
import getConfig from 'next/config';

interface IClearInNavbar {
  data?: TNAVBAR_DATA;
  showPlanVariant?: 'variantA' | 'variantB';
  bgColor?: string;
  isB2CPage?: boolean;
  customRightCTA?: React.ReactNode | null;
  customCTALink?: string;
}

const { publicRuntimeConfig } = getConfig();

const ClearInNavbar = ({
  data = b2bData,
  showPlanVariant,
  bgColor = '',
  isB2CPage = true,
  customRightCTA = null,
  customCTALink = publicRuntimeConfig.SSO_ENDPOINT +
    productReturnPath['default'],
}: IClearInNavbar): JSX.Element => {
  const loginBTN = <LoginButton showPlanVariant={showPlanVariant} />;
  const mobileloginBTN = (
    <LoginButton
      showPlanVariant={showPlanVariant}
      buttonColor={ButtonVariants.bluebordered}
      link={customCTALink}
    />
  );

  return (
    <>
      <div className={`sm:hidden pb-2 ${bgColor}`} data-testid="clear-navbar">
        <DesktopNavBar
          logo={data.logo}
          rightCTA={customRightCTA || data.rightCTA || loginBTN}
          type={data.type}
          bgColor={bgColor}
        />
        {/* height same as navbar height is added to avoid the body content being hided as the navbar is fixed */}
        <div className="h-14"></div>
      </div>
      <div className={`hidden sm:block`}>
        <MobileNavBar
          logo={data.logo}
          type={data.type}
          rightCTA={customRightCTA || mobileloginBTN}
          bgColor={bgColor}
          isB2CPage={isB2CPage}
        />
      </div>
    </>
  );
};

export { ClearInNavbar };
